<template>
  <div class="store-manage-page">
    <div class="page-header">
      <div class="page-header__info">
        <h2 class="page-title">店铺管理</h2>
        <p class="page-desc">管理店铺信息、上下架与浏览量展示</p>
      </div>
      <el-button icon="el-icon-plus" type="primary" @click="onShowSave('新增')">新增店铺</el-button>
    </div>

    <div class="manage-card">
      <el-tabs v-model="stateValue" class="manage-tabs" @tab-click="tabClick">
        <el-tab-pane v-for="(state,j) in status" :key="j" :label="state" :name="state"/>
      </el-tabs>

      <div class="filter-bar">
        <el-form :model="params" class="filter-form" inline @submit.native.prevent="search">
          <el-form-item label="市场">
            <el-select v-model="params.marketplaceId" clearable placeholder="全部市场">
              <el-option v-for="item in place" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="filter-actions">
          <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </div>
      </div>

      <div class="store-manage-page__table">
        <el-table v-loading="loadTable" :data="records" row-key="id" size="small" stripe>
          <el-table-column fixed label="ID" prop="id" width="72"/>
          <el-table-column fixed label="店铺信息" min-width="220">
            <template slot-scope="{ row }">
              <div class="item-info">
                <el-image :preview-src-list="[row.coverImg]" :src="row.coverImg" class="item-info__cover" fit="cover"/>
                <div class="item-info__body">
                  <div :title="row.name" class="item-info__title">{{ row.name }}</div>
                  <div class="item-info__meta">{{ row.placeName || '未分配市场' }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="浏览量" prop="lookNum" width="80"/>
          <el-table-column align="center" label="浏览量显示" width="100">
            <template slot-scope="{ row }">
              <el-tag :type="row.isShowLookNum === '是' ? 'success' : 'info'" effect="plain" size="mini">
                {{ row.isShowLookNum === '是' ? '已开启' : '已关闭' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态" width="80">
            <template slot-scope="{ row }">
              <el-tag :type="row.state === '上' ? 'success' : 'info'" effect="light" size="mini">
                {{ row.state === '上' ? '上架' : '下架' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="160" prop="createdTime" show-overflow-tooltip/>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="{ row, $index }">
              <div class="row-actions">
                <el-button size="mini" type="text" @click="onShowSave('修改', row)">编辑</el-button>
                <el-button size="mini" type="text" @click="skipToStoreType(row)">商品类型</el-button>
                <el-dropdown trigger="click" @command="cmd => handleRowCommand(cmd, row, $index)">
                  <el-button size="mini" type="text">
                    更多<i class="el-icon-arrow-down el-icon--right"/>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="moveUp" :disabled="$index === 0">上移</el-dropdown-item>
                    <el-dropdown-item command="moveDown" :disabled="$index === records.length - 1">下移</el-dropdown-item>
                    <el-dropdown-item v-if="row.state==='下'" command="shelfUp" divided>上架</el-dropdown-item>
                    <el-dropdown-item v-if="row.state==='上'" command="shelfDown">下架</el-dropdown-item>
                    <el-dropdown-item v-if="row.isShowLookNum==='是'" command="lookOff" divided>关闭浏览量</el-dropdown-item>
                    <el-dropdown-item v-if="row.isShowLookNum==='否'" command="lookOn">开启浏览量</el-dropdown-item>
                    <el-dropdown-item v-if="row.isEnableVideoChat==='是'" command="videoChatOff" divided>关闭通话</el-dropdown-item>
                    <el-dropdown-item v-if="row.isEnableVideoChat==='否'" command="videoChatOn">开启通话</el-dropdown-item>

                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-footer">
        <page :current="current" :size="size" :total="total"/>
      </div>
    </div>

    <!--  保存  -->
    <el-dialog
        :title="title"
        :visible.sync="showSave"
        width="30%"
        center>

      <el-form label-position="left" label-width="130px" :model="save" ref="ruleForm">
        <el-form-item label="店铺名" prop="name"
                      :rules="[
                        {required: true, message: '请输入店铺名', trigger: 'blur'},
                        {max: 50, message: '长度最高为50', trigger: 'blur'}
                        ]">
          <el-input v-model="save.name" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="标题颜色" prop="titleColor"
                      :rules="[
                        {required: true, message: '请选择标题颜色', trigger: 'blur'}
                        ]">
          <div class="block">
            <el-color-picker v-model="save.titleColor"></el-color-picker>
          </div>
        </el-form-item>
        <el-form-item label="封面" prop="coverImg"
                      :rules="[
                        {required: true, message: '请上传封面', trigger: 'blur'},
                        ]">
          <div class="avatar-uploader">
            <el-upload
                :action="fileBaseUrl"
                :show-file-list="false"
                :data="uploadData"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
            >
              <img v-if="save.coverImg" :src="save.coverImg" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="背景颜色" prop="color"
                      :rules="[
                        {required: true, message: '请选择背景颜色', trigger: 'blur'}
                        ]">
          <div class="block">
            <el-color-picker v-model="save.color"></el-color-picker>
          </div>
        </el-form-item>
        <el-form-item label="市场" prop="marketplaceId"
                      :rules="[
                        {required: true, message: '请选择市场', trigger: 'blur'},
                        ]">
          <el-select v-model="save.marketplaceId" clearable placeholder="请选择市场">
            <el-option
                v-for="item in place"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电话" prop="phone"
                      :rules="[
                        {required: true, message: '请输入电话', trigger: 'blur'},
                        {max: 11, message: '长度最高为11', trigger: 'blur'}
                        ]">
          <el-input v-model="save.phone" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="是否隐藏" prop="isHide"
                      :rules="[
                        {required: true, message: '请选择是否隐藏', trigger: 'blur'},
                        ]">
          <el-select v-model="save.isHide" clearable placeholder="请选择是否隐藏">
            <el-option
                v-for="item in isHides"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="简介" prop="intro">
          <el-input v-model="save.intro" clearable type="textarea" autosize></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <template>
            <div style="cursor: pointer;width: 20px;display: inline-block" @click="onShowMap">
              <i
                  class="el-icon-location hostlocation"
              ></i>
            </div>
            <div style="display: inline-block"><el-input v-model="save.address"></el-input></div>
          </template>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showSave = false">取 消</el-button>
        <el-button type="primary" @click="doSave('ruleForm')">提 交</el-button>
      </span>
    </el-dialog>

    <!--  上下架  -->
    <el-dialog
        title="提示"
        :visible.sync="showChangeState"
        width="30%"
        center>
      <div style="align-content: center">您确认要{{changeState.state=='上'?'上架':'下架'}}ID为 {{changeState.id}} 吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showChangeState = false">取 消</el-button>
        <el-button type="primary" @click="doChangeState">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除 -->
    <el-dialog
        title="提示"
        :visible.sync="showDel"
        width="30%"
        center>
      <div style="align-content: center">您确认要删除吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDel = false">取 消</el-button>
        <el-button type="primary" @click="doDel">确 定</el-button>
      </span>
    </el-dialog>

    <!--  地图选点  -->
    <el-dialog title="选择位置" :visible.sync="mapVisible" :fullscreen=false  id="mapDialog" :close-on-click-modal="false" style="margin-top: 8.5vh;">
      <div style="margin-bottom: 10px">
        <label>关键词：<input v-model="keyword" class="lineinput" style="width:200px" size="mini"></label>
        <label>地区：<input v-model="location" class="lineinput" style="width:200px" size="mini"></label>
      </div>
      <baidu-map class="map" :center="center" :zoom="zoom" @ready="handler"
                 :scroll-wheel-zoom="true"
                 @click="clickEvent"
      >
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
        <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"  :showAddressBar="true" :autoLocation="true" @locationSuccess="getLoctionSuccess" ></bm-geolocation>
        <bm-view :style="{width:'100%',height: '300px',flex: 1,marginTop:'0px'}"></bm-view>
        <bm-local-search :autoViewport="true" :keyword="keyword" :auto-viewport="false" :location="location" style="height: 150px;overflow-y: scroll;margin: 2px 0"></bm-local-search>
      </baidu-map>
      <div class="demo-input-suffix" style="margin-top: 2vh">
        <el-link type="info">经度：</el-link><el-input  class="lineinput"  style="width:200px" size="mini" v-model.number="locData.longitude" :disabled="true"></el-input>
        <el-link type="info"> 纬度：</el-link><el-input  class="lineinput"  style="width:200px" size="mini" v-model.number="locData.latitude" :disabled="true"></el-input><br>
        <el-link type="info"> 位置：</el-link><el-input  class="lineinput"  style="width:200px" size="mini" v-model="locData.address"></el-input>
      </div>
      <div slot="footer" class="dialog-footer" style="margin-top: -30px">
        <el-button type="warning"  size="small" icon="el-icon-close" @click.native="mapVisible = false">关闭</el-button>
        <el-button type="info"  size="small" icon="el-icon-close" @click="clearMarker">清空标记</el-button>
        <el-button type="primary" size="small" icon="el-icon-check" @click.native="insertLocation">插入地点</el-button>
      </div>
    </el-dialog>

    <!--    插入定位 -->
    <el-dialog
        title="插入定位(只支持腾讯地图坐标)"
        :visible.sync="showAddCoord"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="coord" ref="coordForm">
        <el-form-item label="坐标" prop="lnglat"
                      :rules="[
                        {required: true, message: '请输入坐标', trigger: 'blur'},
                        {max: 255, message: '长度最高为255', trigger: 'blur'}
                        ]">
          <el-input
              clearable
              placeholder="请输入坐标"
              v-model="coord.lnglat">
          </el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address"
                      :rules="[
                        {required: true, message: '请输入地址', trigger: 'blur'},
                        {max: 255, message: '长度最高为255', trigger: 'blur'}
                        ]">
          <el-input
              clearable
              placeholder="请输入地址"
              v-model="coord.address">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddCoord = false">取 消</el-button>
        <el-button type="primary" size="small" icon="el-icon-check" @click.native="insertLocation('coordForm')">插入地点</el-button>
      </span>
    </el-dialog>



  </div>
</template>

<script>

import {Message} from "element-ui";
import getAliyunOssSign from "@/api/common/getAliyunOssSign";
import swapOrder from "@/api/store/StoreShop/swapOrder";
import changeState from "@/api/store/StoreShop/changeState";
import remove from "@/api/store/StoreShop/remove";
import save from "@/api/store/StoreShop/save";
import marketPlaceList from "@/api/store/StoreMarketPlace/list";
import storeShopPage from "@/api/store/StoreShop/page";
import Page from "@/components/Page.vue";
import agencyOpenCloseVideoChat from "@/api/store/StoreShop/agencyOpenCloseVideoChat";
import openCloseShopLookNum from "@/api/store/StoreShop/openCloseShopLookNum";
import adminGetFileSignUrl from "@/api/common/adminGetFileSignUrl";


export default {
  name: "StoreShopManage",
  components: {Page},
  data() {
    return {
      current:1,
      size:10,
      total: 0,
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      uploadData:{},
      params: {},
      loadTable: false,
      records: [],
      place: [],
      defaultVideoChatUserId:undefined,

      status:['上架','下架'],
      stateValue:'上架',

      state:'上',

      showSave:false,
      isHides:[
        {
          value:'是',
          label:'是',
        },
        {
          value:'否',
          label:'否',
        },
      ],
      title:undefined,
      save:{},

      mapVisible:false,
      keyword: '',
      location: '',
      center: {lng: 111.752912, lat: 40.832246},
      zoom: 12,
      locData:{
        longitude:'',
        latitude:'',
        address:'',
      },

      showChangeState:false,
      changeState:{},
      delId: undefined,
      showDel: false,


      showAddCoord:false,
      coord:{
        lnglat:'',
        address:'',
      },



    }
  },

  watch:{
    'save.height'(n){
      if(n==='')this.save.height=0
    },
  },
  methods: {
    // 处理行命令
    handleRowCommand(command, row, $index) {
      switch (command) {
        case 'moveUp':
          this.move(row, true)
          break
        case 'moveDown':
          this.move(row, false)
          break
        case 'shelfUp':
          this.onChangeState(row.id, '上')
          break
        case 'shelfDown':
          this.onChangeState(row.id, '下')
          break
        case 'lookOff':
          this.onOpenCloseLookNum(row.id, '否')
          break
        case 'lookOn':
          this.onOpenCloseLookNum(row.id, '是')
          break
        case 'videoChatOff':
          this.doOpenCloseVideChat(row, '否')
          break
        case 'videoChatOn':
          this.doOpenCloseVideChat(row, '是')
          break

      }
    },
    onOpenCloseLookNum(id, isShowLookNum){
      openCloseShopLookNum(id, isShowLookNum).then(res=>{
        if(res.code==1){
          Message({
            message:'成功',
            type:"success",
            duration:3000
          })
          this.fetchData()
        }else{
          Message({
            message:'失败',
            type:"error",
            duration:3000
          })
        }
      })
    },
    doOpenCloseVideChat(row,state){
      agencyOpenCloseVideoChat(row.id,state).then(res=>{
        if(res.code!=1){
          if(res.data && res.data.illError){
            Message({
              message: res.data.illError,
              type: 'error',
              duration: 3 * 1000
            });
          }else{
            Message({
              message: res.msg,
              type: 'error',
              duration: 3 * 1000
            });
          }
        }else {
          Message({
            message: '成功',
            type: 'success',
            duration: 3 * 1000
          });
          this.fetchData()
        }
      })
    },
    //插入地点
    insertLocation(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const lnglat = this.coord.lnglat.split(',')
          if (lnglat.length!=2) return Message({message:'请正确输入坐标',type:"error",duration:3000})

          this.save.address=this.coord.address
          this.save.lng=lnglat[1]
          this.save.lat=lnglat[0]

          this.showAddCoord = false
          Message({
            message: "成功",
            type: "success",
            duration: 3000
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });


      // let lng = this.locData.longitude
      // let lat = this.locData.latitude
      // let address = this.locData.address
      // if(!lng || !lat || !address){
      //   return Message({
      //     message:'请点击地图选择地点 ',
      //     type: "error",
      //     duration: 3000,
      //   })
      // }
      // adminGetCoords({lng:lng,lat:lat}).then(res=>{
      //   let data = JSON.parse(res.data)
      //   let coords = data.result[0]
      //   this.save.address=address
      //   this.save.lng=coords.x
      //   this.save.lat=coords.y
      //   Message({
      //     message: "成功",
      //     type: "success",
      //     duration: 3000
      //   })
      //   this.mapVisible=false
      // })
    },
    //清空标记
    clearMarker(){
      let keyword = this.keyword
      let location = this.location
      this.keyword = keyword+'a'
      this.location = location+'a'
      let that = this
      let timer = setInterval(function () {
        that.keyword = keyword
        that.location = location
        clearInterval(timer)
      },1000)
      this.locData = {
        longitude:'',
        latitude:'',
        address:'',
      }
    },
    //定位成功回调
    getLoctionSuccess(point){
      window.map.clearOverlays();
      let Icon_0 = new window.BMap.Icon("http://api0.map.bdimg.com/images/marker_red_sprite.png", new window.BMap.Size(64, 64), {anchor: new window.BMap.Size(18, 32),imageSize: new window.BMap.Size(36, 36)});
      let myMarker = new window.BMap.Marker(new window.BMap.Point(point.point.lng, point.point.lat),{icon: Icon_0});
      window.map.addOverlay(myMarker);
      this.locData.longitude = point.point.lng;
      this.locData.latitude = point.point.lat;
    },
    //点击地图监听
    clickEvent(e){
      window.map.clearOverlays();
      let Icon_0 = new window.BMap.Icon("https://hl-tianxia.oss-cn-chengdu.aliyuncs.com/upload/common/map.png", new window.BMap.Size(64, 64), {anchor: new window.BMap.Size(18, 32),imageSize: new window.BMap.Size(36, 25)});
      let myMarker = new window.BMap.Marker(new window.BMap.Point(e.point.lng, e.point.lat),{icon: Icon_0});
      window.map.addOverlay(myMarker);
      //用所定位的经纬度查找所在地省市街道等信息
      let point = new window.BMap.Point(e.point.lng, e.point.lat);
      let gc = new window.BMap.Geocoder();
      let _this = this;
      gc.getLocation(point, function (rs) {
        let addComp = rs.addressComponents;
        console.log(addComp)
        _this.locData.address = rs.address;

      });
      this.locData.longitude = e.point.lng;
      this.locData.latitude = e.point.lat;
    },
    skipToStoreType(row){
      localStorage.setItem("storeShopId",row.id)
      this.$router.push({
        name: "商品类型",
      })
    },
    doSave(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.save))
          params.coverImg=params.coverImg.split('?')[0].substring(this.fileBaseUrl.length+1)
          save(params).then(res=>{
            if(res.code===1){
              Message({message:"成功",type:"success",duration:3000})
              this.showSave=false
              this.fetchData()
            }else{
              if(res.data && res.data.illError){
                Message({message:res.data.illError,type:"error",duration:3000})
              }else{
                Message({message:"失败",type:"error",duration:3000})
              }
            }
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    handler ({BMap, map}) {
      let _this = this;  // 设置一个临时变量指向vue实例，因为在百度地图回调里使用this，指向的不是vue实例；
      let geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function(r){
        _this.center = {lng: r.longitude, lat: r.latitude};   // 设置center属性值
        _this.autoLocationPoint = {lng: r.longitude, lat: r.latitude};  // 自定义覆盖物
        _this.initLocation = true;
      },{enableHighAccuracy: true})
      window.map = map;
      window.BMap = BMap;
    },
    onShowMap(){
      this.showAddCoord = true


      // this.mapVisible = true
    },
    onShowSave(title,row){
      if(this.place.length===0){
        return Message({message:"请先向平台申请市场",type:"error",duration:3000})
      }
      this.title=title
      this.save={
        titleColor: '#000000',
        coverImg: undefined,
        color: '#ffffff',
        isHide:'否',
        adminVideoChatUserId:this.defaultVideoChatUserId,
        address:'',
      }
      if(row){
        this.save=JSON.parse(JSON.stringify(row))
      }
      this.showSave=true
    },
    onShowDel(row){
      this.delId = row.id
      this.showDel = true
    },
    doDel(){
      let that = this
      remove(this.delId).then(res=>{
        if(res.code!=1){
          Message({
            message: '删除失败',
            type: 'error',
            duration: 3 * 1000
          });
        }else {
          Message({
            message: '删除成功',
            type: 'success',
            duration: 3 * 1000
          });
          that.showDel = false
          that.fetchData()
        }
      })
    },
    getUUID() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      var uuid = s.join("");
      return uuid;
    },
    async beforeUpload(){
      await getAliyunOssSign("/common/sign").then(response => {
        console.log(response)
        //设置相关的参数
        let resultObj = response.data;
        this.uploadData = resultObj;
        this.uploadData.ossaccessKeyId = resultObj.accessid;
        //上传的文件名，使用UUID处理一下
        this.uploadData.key = resultObj.dir + '/' + this.getUUID() + '_${filename}';
      });
      return true
    },
    //文件上传成功回调
    handleSuccess(response, file){
      //上传的完整的文件地址
      var urlPath = this.uploadData.host + '/' + this.uploadData.key.replace("${filename}",file.name) ;
      let filepath = urlPath.substring(this.fileBaseUrl.length+1)
      adminGetFileSignUrl(filepath).then(res=>{
        this.save.coverImg=res.data
      })
    },
    tabClick(){
      this.params.marketplaceId=undefined
      if(this.stateValue==='上架'){
        this.state='上'
      }
      if(this.stateValue==='下架'){
        this.state='下'
      }

      this.reset()
    },
    areaChange(e){
      this.params.areaDetailId=undefined
      this.params.provinceId=undefined
      this.params.cityId=undefined
      this.params.areaId=undefined
      if(e.length===1){
        this.params.provinceId=e[0]
      }
      if(e.length===2){
        this.params.cityId=e[1]
      }
      if(e.length===3){
        this.params.areaId=e[2]
      }
    },
    isUp(row){
      return row.id!=this.records[0].id
    },
    isDown(row){
      return row.id!=this.records[this.records.length-1].id
    },
    move(row,isUp){
      swapOrder(row.id,isUp).then(res=>{
        if(res.code===1){
          Message({
            message: '成功',
            type: 'success',
            duration: 3 * 1000
          });
          this.fetchData()
        }
      })
    },
    onChangeState(id,state){
      this.changeState.id=id
      this.changeState.state=state
      this.showChangeState = true
    },
    doChangeState(){
      changeState(this.changeState.id, this.changeState.state).then(res=>{
        if(res.code===1){
          Message({
            message:"成功",
            type:"success",
            duration:3000
          })
          this.showChangeState = false
          this.fetchData()
        }else{
          if(res.data && res.data.illError){
            Message({
              message: res.data.illError,
              type: "error",
              duration:3000
            })
          }else{
            Message({
              message: res.msg,
              type: "error",
              duration:3000
            })
          }
        }
      })
    },
    search(){
      this.fetchData()
    },
    reset(){
      this.current=1
      this.params = {}
      // this.$refs.cascader.panel.checkedValue = []
      this.fetchData()
    },
    fetchData(){
      this.params.state=this.state
      storeShopPage(this.current,this.size,this.params).then(res=>{
        let data = res.data.data
        for(let i=0;i<data.length;i++){
          let e = data[i]
          e.coverImg=this.fileBaseUrl+e.coverImg
        }
        this.records=data
        this.total=res.data.total
      })
    },

    getStoreMarketPlaces(){
      marketPlaceList().then(res=>{
        let data = res.data
        data.sort((a,b)=>a.order-b.order)
        let places = []
        for(let i=0;i<data.length;i++){
          let e = data[i]
          let d = {value:e.id,label:e.name}
          places.push(d)
        }
        this.place=places
      })
    },
  },

  mounted() {
    this.fetchData()
    this.getStoreMarketPlaces()
  },

}
</script>

<style lang="scss" scoped>
.store-manage-page {
  padding: 20px;
  box-sizing: border-box;
  min-height: calc(100vh - 56px);
  background: #f5f7fa;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 0 4px;

  &__info {
    flex: 1;
  }
}

.page-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.page-desc {
  margin: 6px 0 0;
  font-size: 13px;
  color: #9ca3af;
}

.manage-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.manage-tabs {
  ::v-deep .el-tabs__header {
    margin-bottom: 0;
  }
}

.filter-bar {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f2f5;
}

.filter-form {
  display: inline-block;
}

.filter-actions {
  display: inline-block;
  margin-left: 16px;
}

.store-manage-page__table {
  padding: 0 20px;
}

.item-info {
  display: flex;
  align-items: center;
  gap: 12px;

  &__cover {
    width: 48px;
    height: 48px;
    border-radius: 6px;
    border: 1px solid #eef0f3;
    flex-shrink: 0;
  }

  &__body {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-size: 14px;
    font-weight: 500;
    color: #1f2937;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__meta {
    font-size: 12px;
    color: #9ca3af;
    margin-top: 4px;
  }
}

.row-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.table-footer {
  padding: 16px 20px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #f0f2f5;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 60px;

  .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 60px;
    display: block;
  }
}

@media (max-width: 768px) {
  .store-manage-page {
    padding: 12px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .filter-bar {
    padding: 12px;
  }

  .store-manage-page__table {
    padding: 0 12px;
  }
}
</style>
